import { render, staticRenderFns } from "./businessHome.vue?vue&type=template&id=6b640dac&scoped=true"
import script from "./businessHome.vue?vue&type=script&lang=js"
export * from "./businessHome.vue?vue&type=script&lang=js"
import style0 from "./businessHome.vue?vue&type=style&index=0&id=6b640dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b640dac",
  null
  
)

export default component.exports